// import { ShaTS }  from 'sha-ts'
// const { createHash } = require('crypto')
import { sha256, sha224 } from 'js-sha256'

export function sha256Encode(text: string): string {
  return sha256(text)
}
